import { methods } from "../../utils/axios";

export default class CatalogAPI {
  static getCatalog() {
    return methods.get('/catalog');
  }
}
